import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页', icon: 'ri-home-4-line' },
  { path: '/category/mingxing-bagua', label: '明星八卦', icon: 'ri-star-smile-line' },
  { path: '/category/wanghong-heiliao', label: '网红黑料', icon: 'ri-user-smile-line' },
  { path: '/category/baozou-shipin', label: '暴走视频', icon: 'ri-fire-line' },
  { path: '/category/neimu-dagua', label: '内幕大瓜', icon: 'ri-spy-line' },
  { path: '/about', label: '关于我们', icon: 'ri-information-line' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-fire-fill text-primary-500 text-2xl"></i>
            </div>
            <span className="text-lg font-bold tracking-tight text-foreground-50 whitespace-nowrap">
              黑料<span className="text-primary-500">视频</span>
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`relative px-3 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? 'text-primary-500 bg-primary-500/10'
                      : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-100'
                  }`}
                >
                  <span className="flex items-center gap-1.5">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className={`${link.icon} text-base`}></i>
                    </span>
                    {link.label}
                  </span>
                  {isActive && (
                    <span className="absolute bottom-1 left-1/2 -translate-x-1/2 w-4 h-0.5 bg-primary-500 rounded-full" />
                  )}
                </Link>
              );
            })}
          </div>

          {/* Right actions */}
          <div className="flex items-center gap-3">
            <a
              href="#cta"
              className="hidden md:flex items-center gap-2 px-4 py-2 bg-primary-500 hover:bg-primary-600 text-background-950 text-sm font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-rocket-2-line text-sm"></i>
              </span>
              传送门入口
            </a>
            {/* Mobile toggle */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-300 hover:text-foreground-100 transition-colors cursor-pointer"
              aria-label="Toggle menu"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          mobileOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-background-50/95 backdrop-blur-md border-t border-background-200/60 px-4 py-3 space-y-1">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  isActive
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-100'
                }`}
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${link.icon} text-lg`}></i>
                </span>
                {link.label}
              </Link>
            );
          })}
          <a
            href="#cta"
            className="flex items-center gap-3 px-4 py-3 mt-2 rounded-lg bg-primary-500 text-background-950 text-sm font-semibold cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-rocket-2-line text-lg"></i>
            </span>
            传送门入口
          </a>
        </div>
      </div>
    </nav>
  );
}